import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Oui_TypeOuiNonReservationMarche } from '../models/Oui_TypeOuiNonReservationMarche';
@Component({
	selector: 'app-oui-type-oui-non-reservation-marche',
	templateUrl: './oui-type-oui-non-reservation-marche.component.html'
})
export class OuiTypeOuiNonReservationMarcheComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'Oui_TypeOuiNonReservationMarche';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() oui: Oui_TypeOuiNonReservationMarche;

	constructor() {}

	public ngOnInit() {}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
